import { render, staticRenderFns } from "./chatBubble.vue?vue&type=template&id=68556b30&scoped=true&"
import script from "./chatBubble.vue?vue&type=script&lang=ts&"
export * from "./chatBubble.vue?vue&type=script&lang=ts&"
import style0 from "./chatBubble.vue?vue&type=style&index=0&id=68556b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68556b30",
  null
  
)

component.options.__file = "chatBubble.vue"
export default component.exports